import React from "react";
import { MessagesMode } from "../types";

/**
 * Tapahtuman viestiasetus (docs/ideat.md G1): Pois / Vahvistetut / Kaikki.
 * Säännöt (firestore.rules, canPostMessage) lukevat saman kentän, joten
 * valinta pätee palvelimella eikä vain näkymässä.
 */
export default function MessagesModeSelect({ value, onChange, lang, style }: {
  value: MessagesMode;
  onChange: (v: MessagesMode) => void;
  lang: "fi" | "en";
  style?: React.CSSProperties;
}) {
  const fi = lang !== "en";
  return (
    <label style={{ display: "block", fontSize: 11, color: "var(--sl-muted)" }}>
      {fi ? "Viestit" : "Messages"}
      <select value={value} onChange={e => onChange(e.target.value as MessagesMode)}
        style={{ ...style, marginTop: 3, appearance: "auto" as React.CSSProperties["appearance"] }}>
        <option value="verified">{fi ? "Vahvistetut pelaajat kirjoittavat (oletus)" : "Verified players can write (default)"}</option>
        <option value="all">{fi ? "Kaikki osallistujat kirjoittavat" : "All participants can write"}</option>
        <option value="off">{fi ? "Ei viestejä" : "No messages"}</option>
      </select>
      <span style={{ display: "block", marginTop: 3, lineHeight: 1.4 }}>
        {value === "all"
          ? (fi ? "Myös PIN-koodilla kirjautuneet voivat kirjoittaa; heidän viesteihinsä tulee merkintä \"vahvistamaton\"."
                : "PIN sign-ins can write too; their messages are marked \"unverified\".")
          : value === "off"
            ? (fi ? "Viestiosio on piilossa tässä tapahtumassa." : "The messages section is hidden for this event.")
            : (fi ? "Kirjoittaa voivat kutsulinkillä tai vahvistuslinkillä kirjautuneet, järjestäjät ja ylläpito."
                  : "Players signed in via an invite or verification link, organizers and admins can write.")}
      </span>
    </label>
  );
}
